<template>
  <div>
    <div class="service-box">
      <div class="service">
        <div class="service-img">
          <img :src="details.image" alt="service img">
        </div>
        <div class="service-data-box">
          <div class="service-data">
            <div>
              <div>
                <div class="service-max-paxluggage">
                  <div class="pax-luggage">
                    <div class="fa-stack">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fas fa-user fa-stack-1x fa-inverse"></i>
                    </div>
                    <span>{{details.maxPassengers}} max</span>
                  </div>
                  <div class="pax-luggage">
                    <div class="fa-stack">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fas fa-suitcase fa-stack-1x fa-inverse"></i>
                    </div>
                    <span>{{details.maxLuggages}} max</span>
                  </div>
                  <div class="stairs-label">Pick Up: {{ upDownstairs() }}</div>
                </div>
                <div class="service-name">
                  {{details.name}}
                </div>
                <div class="break"></div>
                <div class="service-quote">
                  <div class="service-price">
                    $88.00
                    <div class="one-way-fare">
                    One-way fare
                    </div>
                    <div class="eta margin-t-m margin-b-m">
                      <div style="text-align: center">
                        <span class="no-cars">Book in advance</span>
                      </div>
                    </div>  
                  </div>
                </div>
                <transition name="fade" mode="out-in">
                  <div class="service-desc" v-show="showDescription">
                    <div class="margin-b-s">
                      {{details.descriptionWeb}}
                    </div>
                    <div>
                      <b>[Advantage]</b>
                      <span>{{ details.advantageWeb }}</span>
                    </div>
                    <div class="margin-t-s">
                      <b>[Stops]</b>
                      <span>{{details.stops}}</span>
                    </div>
                  </div>
                </transition>
              </div>
                <div class="service-desc-more margin-t-s">
                  <a @click="showDescription = !showDescription" class="btn-success">
                    <span v-show="!showDescription">More Info</span>
                    <span v-show="showDescription">Hide Info</span>
                  </a>
                </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'preview-mobile',
  props: ['details'],
  computed: {
    licenseType () {
      console.log(this.$store.state.services.details)
      }
  },
  data() {
    return {
      showDescription: false
    }
  },
  methods: {
    upDownstairs () { return this.details.allowTNC ? 'UPSTAIRS' : 'DOWNSTAIRS' }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.services{
  padding: 10px 0;
  position: relative;
}

.service-box{
  width: 370px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  max-height: 999px;
  padding: 10px 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-family: Questrial,sans-serif;
}
.service {
  background-color: #d0d0d0;
  border: 2px solid #ccc;
  border-radius: 3px;
  width: 100%;
  display: block;
  margin-right: 11px;
  margin-bottom:0!important;
  text-align: center;
  padding: 0;
  cursor: pointer;
  transition: all .3s ease;

  &:hover:not(.disabled), &.active { border: 2px solid #13bcac; }
  &.disabled{
    opacity: .65;
    cursor: default;
  }

  &.no-margin { margin-right: 0; }

  .service-img {
    position: relative;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    height: 150px;

    img{
      max-width: 100%;
      max-height: 150px;
      position: relative;
      top: 50%;
    }
  }

  .service-data-box{ background: #f6f6f6; }
  .service-data{
    width: 100%;
    // display: table-cell;
    text-align: left;
    padding: 15px;
    position: relative;
    z-index: 2;

    .break {
      height: 24px;
      width: 100%;
      margin-bottom: 10px;
    }
  }

  .service-max-paxluggage {
    font-size: 12px;
    line-height: 12px;
    margin-bottom: 20px;
    text-align: center;

    .pax-luggage{
      display: inline-block;
      color: #838d98;
      padding: 0 5px;
    }
    .stairs-label{
      display: inline-block;
      padding: 3px 5px;
      color: #838d98;
      font-weight: 600;
    }
    .fa-stack{
      width: 2em;  
      i {
        width: 24px;
      }
    }
  }
  .service-name {
    font-size: 24px;
    font-weight: 700;
    margin-bottom:5px;
    line-height: 18px;
    text-align: center;
  }
  .service-desc-excerpt, .service-desc{
    color: #838d98;
    line-height: 125%;
    margin-bottom: 7px;
  }
  .service-desc-more{
    font-size: 13px;
    font-weight: 600;
    color: #13bcac;
    text-align: center;
  }

  .service-quote{ padding: 0 10px; }
  .service-price {
    font-size: 28px;
    font-weight: 700;
    color: #13bcac;
    line-height: 18px;
    margin-bottom: 10px;
    text-align: center;

    .shared-error{
      font-size: 13px;
      color: #ff4a4a;
      line-height: 1.4
    }
    .suggested-service{
      font-size: 14px;
      color: #2c3e50;
      line-height: 1.4;
      margin-top:10px;
      cursor:pointer;
      text-decoration: underline;
    }
  }
  .service-discount-info{
    text-align: right;

    span{ display: inline-block; }
    .service-original-price{
      font-size: 18px;
      margin-right: 5px;
      position: relative;
      color: #ccc;
      vertical-align: middle;

      &:after{
        content: '';
        border-bottom:1px solid rgba(255,0,0, .5);
        position: absolute;
        top:50%;
        left: 0;
        width: 100%;
      }
    }
    .service-discount-saved{
      font-size: 12px;
      color: #fff;
      background: #d55556;
      padding: 2px 4px;
      vertical-align: middle;
      border-radius: 3px;
    }
  }
  .service-discount-timer{
    margin-top:15px;
    color: #777;
    text-align: right;

    div{ font-size: 13px; }
    .timer{ font-size:15px;}
  }

  .eta{
    text-align: right;

    span{ display: block; }
    .minutes-away, .no-cars{
      font-size: 13px;
      color: #aaa;
    }
    .suggested-pickup-time{
      font-size: 14px;
      padding-top: 12px;

      &.not-allowed{ color: #ea4242; }
      a{
        text-decoration: underline;
        font-weight: 600;
      }
      i{
        margin-left: 3px;
        vertical-align: 1px;
      }
    }
    .dropoff-time{
      line-height: 1.1;
      font-size: 14px;
      color: #777;
    }
    .no-cars{ font-style: italic; }
  }

  .mng{
    text-align: right;
    font-size: 13px;
    color: #ea5427;
  }

  .loader-box{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0,0,0, 0);
    transition: all .3s ease-in;

    &.show{
      z-index: 3;
      background: rgba(0,0,0, .4);
    }
    .spinner-box{
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -18px;
      margin-top: -18px;
    }
    .fa-spinner{
      font-size: 36px;
    }
  }
}

.medium-below{
  .icon-font, .logo{ text-align: center!important; }
  &.pricing{
    margin-bottom: 15px;

    .service-quote{ padding: 0; }
    .service-price{
      text-align: center;
      line-height: 18px;
      margin-bottom: 10px;
      font-size:28px;
      .shared-error{ margin-top: 5px; }
    }
    .service-discount-timer{
      margin-top: 3px;
      line-height: 10px;
      span{ font-size:12px!important; }
    }
    .service-discount-info, .service-discount-timer{ text-align: center; }
  }
  &.service-desc-more{ clear:both; }
  .eta, .mng{ text-align: center; }
}

.one-way-fare{
  font-size: 12px;
  color: #999;
}

.margin-t-m { margin-top: 20px}
.margin-b-s { margin-bottom: 10px}
.margin-t-s { margin-top: 10px}

b { color: #353535}

.btn-success {
  background: #3ac568;
  border-color: #0f943b;
  color: #fff!important;
  width: 100%;
  display: block;
  text-align: center;
  padding: 10px;
  font-size: .8em;
  border-radius: 4px;
  border: 1px solid #b1b1b1;
  outline: 0;
  -webkit-transition: all .3s ease;
  transition: all .3s ease;
  -webkit-box-shadow: inset 0 -3px 0 0 rgba(0,0,0,.15), 0 2px 5px rgba(0,0,0,.2);
  box-shadow: inset 0 -3px 0 0 rgba(0,0,0,.15), 0 2px 5px rgba(0,0,0,.2);
  cursor: pointer;
  line-height: 1em;
}

.btn-success:hover {
  background: #23b051;
  -webkit-box-shadow: inset 0 -3px 0 0 rgba(0,0,0,.15);
  box-shadow: inset 0 -3px 0 0 rgba(0,0,0,.15);
}

@media only screen and (max-width: 430px) {
  .service-box {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Services/PreviewMobile.vue